// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getWishListLines } from "@bg/App/Services/WishListService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    if (!props.wishListLines) {
        props.apiResult = await getWishListLines(props.apiParameter);
        props.wishListLines = props.apiResult.wishListLines!;
    }
};

export const XngExecuteOnSuccessCallback: typeof ExecuteOnSuccessCallback = props => {
    props.parameter.onSuccess?.();
    props.apiResult?.wishListLines?.forEach(line => {
        props.dispatch({
            type: "Pages/MyListDetails/UpdateQuantity",
            wishListLineId: line.id,
            qtyOrdered: line.qtyOrdered,
        });
    });
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
